// extracted by mini-css-extract-plugin
export var equalColumn = "_ht-0";